import React from 'react';
import * as R from 'ramda';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { MDropdown } from 'common';
import { ANY_VALUE } from 'feature/loading-management/utils/const';

import {
  MY_AUTH_TYPE_FILTER_OPTIONS,
  SUPPLIER_EXCHANGE_FILTER_OPTIONS,
  SUPPLIER_STATUS_FILTER_OPTIONS,
} from 'utils/constants';

const FiltersPopover = ({
  cancelButtonStyles,
  filters: { active, exchange, inventoryOwner, limitType, location, product, state },
  handleClose,
  inventoryOwnerOptions,
  lgUp,
  locationOptions,
  productOptions,
  resetCardFilters,
  setFilters,
  stateOptions,
}) => {
  const showClear = R.o(
    R.not,
    R.all(R.equals(ANY_VALUE))
  )([active, exchange, inventoryOwner, limitType, location, product, state]);

  return (
    <>
      {!lgUp && (
        <>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5">Filters</Typography>
            <IconButton onClick={handleClose} size="large" sx={cancelButtonStyles}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>
          <Divider />
        </>
      )}
      {inventoryOwnerOptions?.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="inventory-owner-select"
          items={inventoryOwnerOptions}
          label="Inv. Owner"
          name="inventoryOwner"
          onChange={setFilters}
          value={inventoryOwner}
        />
      )}
      {locationOptions?.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="location-select"
          items={locationOptions}
          label="Location"
          name="location"
          onChange={setFilters}
          value={location}
        />
      )}
      {productOptions?.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="product-select"
          items={productOptions}
          label="Product"
          name="product"
          onChange={setFilters}
          value={product}
        />
      )}
      {stateOptions?.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="state-select"
          items={stateOptions}
          label="State"
          name="state"
          onChange={setFilters}
          value={state}
        />
      )}
      <MDropdown
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        id="exchange-select"
        items={SUPPLIER_EXCHANGE_FILTER_OPTIONS}
        label="Exchange"
        name="exchange"
        onChange={setFilters}
        value={exchange}
      />
      <MDropdown
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        id="limitType"
        items={MY_AUTH_TYPE_FILTER_OPTIONS}
        label="Type"
        name="limitType"
        onChange={setFilters}
        value={limitType}
      />
      <MDropdown
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'top',
        }}
        id="active"
        items={SUPPLIER_STATUS_FILTER_OPTIONS}
        label="Status"
        name="active"
        onChange={setFilters}
        value={active}
      />
      {showClear && (
        <Button
          onClick={() => resetCardFilters()}
          sx={{
            mx: 'auto',
            my: 1,
          }}
          variant="text"
        >
          Clear
        </Button>
      )}
    </>
  );
};

FiltersPopover.propTypes = {
  cancelButtonStyles: shape({}).isRequired,
  filters: shape({
    state: string.isRequired,
  }).isRequired,
  handleClose: func.isRequired,
  inventoryOwnerOptions: arrayOf(shape({})).isRequired,
  lgUp: bool.isRequired,
  locationOptions: arrayOf(shape({})).isRequired,
  productOptions: arrayOf(shape({})).isRequired,
  resetCardFilters: func.isRequired,
  setFilters: func.isRequired,
  stateOptions: arrayOf(shape({})).isRequired,
};

export default FiltersPopover;
